import { get } from 'helpers/api';

export const LOAD_RELATED_DEALS = 'LOAD_RELATED_DEALS';
export function loadRelatedDeals() {
  return async (dispatch, getState) => {
    const relatedDeals = await get(getState().paths.relatedDeals);
    dispatch(setRelatedDeals(relatedDeals));
  };
}

export const SET_RELATED_DEALS = 'SET_RELATED_DEALS';
export function setRelatedDeals(relatedDeals) {
  return {
    type: SET_RELATED_DEALS,
    relatedDeals,
  };
}